import { Col, Row } from 'react-bootstrap'

const TeacherCard = ({ teacher, setShowBookNow, setSelectedTeacher }) => (
  <div className='teacher-card' key={teacher.id}>
    <div className='teacher-card-img-container'>
      <img src={teacher.profile_pic} alt={'User Profile'} />
    </div>
    <div className='teacher-card-body'>
      <div className='teacher-card-title'>
        <h2
          style={{
            fontWeight: 'bold',
            color: 'green',
          }}
        >
          {teacher.user_name}
        </h2>
      </div>

      <div className='teacher-card-description'>
        <Row>
          <Col sm={12} md={12} lg={4}>
            <p>
              <b>Mode: </b>
              <span className='availability available'>
                {teacher.teaching_mode}
              </span>
            </p>
            <p>
              <b>Job:</b> <span>{teacher.job_type}</span>
            </p>
            <p>
              <b>Emirate/City: </b>
              <span>{teacher.emirates}</span>
            </p>

            <p>
              <b>Experience: </b>
              <span>{teacher.experience}</span>
            </p>
          </Col>
          <Col sm={12} md={12} lg={4}>
            <p>
              <b>Availability:</b>
            </p>
            <div className='teacher-availability'>
              <div className='availability-container'>
                <span
                  className={`availability ${
                    teacher.availablity?.includes('Sunday')
                      ? 'available'
                      : 'unavailable'
                  }`}
                  title={
                    teacher.availablity?.includes('Sunday')
                      ? 'Available'
                      : 'Not Available'
                  }
                >
                  Sunday
                </span>
                <span
                  className={`availability ${
                    teacher.availablity?.includes('Monday')
                      ? 'available'
                      : 'unavailable'
                  }`}
                  title={
                    teacher.availablity?.includes('Monday')
                      ? 'Available'
                      : 'Not Available'
                  }
                >
                  Monday
                </span>
              </div>
              <div className='availability-container'>
                <span
                  className={`availability ${
                    teacher.availablity?.includes('Tuesday')
                      ? 'available'
                      : 'unavailable'
                  }`}
                  title={
                    teacher.availablity?.includes('Tuesday')
                      ? 'Available'
                      : 'Not Available'
                  }
                >
                  Tuesday
                </span>
                <span
                  className={`availability ${
                    teacher.availablity?.includes('Wednesday')
                      ? 'available'
                      : 'unavailable'
                  }`}
                  title={
                    teacher.availablity?.includes('Wednesday')
                      ? 'Available'
                      : 'Not Available'
                  }
                >
                  Wednesday
                </span>
              </div>
              <div className='availability-container'>
                <span
                  className={`availability ${
                    teacher.availablity?.includes('Thursday')
                      ? 'available'
                      : 'unavailable'
                  }`}
                  title={
                    teacher.availablity?.includes('Thursday')
                      ? 'Available'
                      : 'Not Available'
                  }
                >
                  Thursday
                </span>
                <span
                  className={`availability ${
                    teacher.availablity?.includes('Friday')
                      ? 'available'
                      : 'unavailable'
                  }`}
                  title={
                    teacher.availablity?.includes('Friday')
                      ? 'Available'
                      : 'Not Available'
                  }
                >
                  Friday
                </span>
              </div>
              <div className='availability-container'>
                <span
                  className={`availability ${
                    teacher.availablity?.includes('Saturday')
                      ? 'available'
                      : 'unavailable'
                  }`}
                  title={
                    teacher.availablity?.includes('Saturday')
                      ? 'Available'
                      : 'Not Available'
                  }
                >
                  Saturday
                </span>
                <span
                  className='availability available'
                  style={{ visibility: 'hidden' }}
                ></span>
              </div>
            </div>
          </Col>
          <Col sm={12} md={12} lg={4}>
            <p>
              <b>Time Slot:</b>
            </p>
            <div className='teacher-availability'>
              <div className='availability-container'>
                <span
                  className={`availability ${
                    teacher.time_slot?.includes('9AM-12PM')
                      ? 'available'
                      : 'unavailable'
                  }`}
                  title={
                    teacher.time_slot?.includes('9AM-12PM')
                      ? 'Available'
                      : 'Not Available'
                  }
                >
                  9AM-12PM
                </span>
                <span
                  className={`availability ${
                    teacher.time_slot?.includes('12PM-3PM')
                      ? 'available'
                      : 'unavailable'
                  }`}
                  title={
                    teacher.time_slot?.includes('12PM-3PM')
                      ? 'Available'
                      : 'Not Available'
                  }
                >
                  12PM-3PM
                </span>
              </div>
              <div className='availability-container'>
                <span
                  className={`availability ${
                    teacher.time_slot?.includes('3PM-6PM')
                      ? 'available'
                      : 'unavailable'
                  }`}
                  title={
                    teacher.time_slot?.includes('3PM-6PM')
                      ? 'Available'
                      : 'Not Available'
                  }
                >
                  3PM-6PM
                </span>
                <span
                  className={`availability ${
                    teacher.time_slot?.includes('6PM-9PM')
                      ? 'available'
                      : 'unavailable'
                  }`}
                  title={
                    teacher.time_slot?.includes('6PM-9PM')
                      ? 'Available'
                      : 'Not Available'
                  }
                >
                  6PM-9PM
                </span>
              </div>
            </div>
          </Col>
          <Col md={12}></Col>
        </Row>
      </div>
      <div className='teacher-card-footer'>
        <p>
          <b>Experties: </b>
          <span>{teacher.expertise}</span>
        </p>
        <button
          className='RegButton'
          onClick={() => {
            setShowBookNow(true)
            setSelectedTeacher(teacher.id)
          }}
        >
          View
        </button>
      </div>
    </div>
  </div>
)

export default TeacherCard
